import axios from "axios";
import { MemberTaskCount } from "../../types";
import { Policy } from "../policyIssues/types";
import { countAndMapAssignedTasks } from "./commonUtils";

export const getPoliciesWithIssuesUniqueAssignedToList = (
    policiesWithIssues: Policy[]
  ): MemberTaskCount[] => countAndMapAssignedTasks(policiesWithIssues, "Policies With Issues");

export const searchPoliciesWithIssues = async () => {
    const { data } = await axios.get<Policy[]>("/api/OutstandingChecks/GetPoliciesWithIssuesForDashboard");
    return data;
  };
